export default __webpack_public_path__ + "static/media/Povify.cfbb136b244b42e3c1a40cd2038d6483.webp";